export default __webpack_public_path__ + "static/media/double-deep.2e81041d.png";